import request from '@/utils/request'


// 会员列表查询
export const queryMemberList = (params) => {
  return request({
    url: '/tinggoadmin/member/list',
    method: 'get',
    params
  })
}

// 会员详情查询
export const queryMemberDetail = (memberId) => {
  return request({
    url: `/tinggoadmin/member/detail/${memberId}`,
    method: 'get'
  })
}

// 启用/禁用会员
export const enableOrDisableMember = (memberId) => {
  return request({
    url: `/tinggoadmin/member/enableOrDisable/${memberId}`,
    method: 'put'
  })
}

// 注销会员
export const cancelMember = (memberId) => {
  return request({
    url: `/tinggoadmin/member/cancel/${memberId}`,
    method: 'put'
  })
}

// API调用日志查询
export const queryApiLogList = (params) => {
  return request({
    url: '/tinggoadmin/member/apiLog/list',
    method: 'get',
    params
  })
}

// 登录日志查询
export const queryLoginLogList = (params) => {
  return request({
    url: '/tinggoadmin/member/loginLog/list',
    method: 'get',
    params
  })
}
